// App.js
import React, { useState } from 'react';
import './App.css';

function App() {
  const [options, setOptions] = useState({
    lowercase: true,
    uppercase: true,
    numbers: true,
    symbols: false,
    length: 10,
    count: 10
  });
  
  // Генерация начальных паролей при загрузке
  const generateInitialPasswords = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const initialPasswords = [];
    for (let i = 0; i < 10; i++) {
      let password = '';
      for (let j = 0; j < 10; j++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        password += chars[randomIndex];
      }
      initialPasswords.push(password);
    }
    return initialPasswords;
  };

  const [passwords, setPasswords] = useState(generateInitialPasswords());
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  
  // Функция для копирования пароля в буфер обмена
  const copyToClipboard = (password, index) => {
    navigator.clipboard.writeText(password)
      .then(() => {
        setCopiedIndex(index);
        // Сбросить статус "скопировано" через 2 секунды
        setTimeout(() => {
          setCopiedIndex(null);
        }, 2000);
      })
      .catch(err => {
        console.error('Не удалось скопировать: ', err);
      });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setOptions({ ...options, [name]: checked });
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Убедимся, что значение не превышает максимум
    const numValue = Math.min(Math.max(parseInt(value) || 0, 1), 99);
    setOptions({ ...options, [name]: numValue });
  };
  
  const generatePasswords = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      // Проверим, выбран ли хотя бы один тип символов
      const hasSelectedOptions = options.lowercase || options.uppercase || 
                               options.numbers || options.symbols;
      
      if (!hasSelectedOptions) {
        throw new Error('Выберите хотя бы один тип символов');
      }
      
      // Локальная генерация паролей (без обращения к API)
      const chars = [
        options.lowercase ? 'abcdefghijklmnopqrstuvwxyz' : '',
        options.uppercase ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' : '',
        options.numbers ? '0123456789' : '',
        options.symbols ? '!@#$%^&*()_+-=[]{}|;:,.<>?' : ''
      ].join('');
      
      const generatedPasswords = [];
      for (let i = 0; i < options.count; i++) {
        let password = '';
        for (let j = 0; j < options.length; j++) {
          const randomIndex = Math.floor(Math.random() * chars.length);
          password += chars[randomIndex];
        }
        generatedPasswords.push(password);
      }
      
      setPasswords(generatedPasswords);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="App">
      <header className="App-header">
        <h1>Онлайн Генератор паролей</h1>
      </header>
      
      <main className="container">
        <div className="password-generator">
          <p>Здесь вы можете сами создать пароль любой длины и любой сложности.</p>
          
          <div className="options-section">
            <div className="charset-options">
              <p>Символы из которых будет сгенерирован ваш пароль:</p>
              <div className="charset-display">
                {options.numbers && '1234567890'}
                {options.uppercase && 'ZYXWVUTSRQPONMLKJIHGFEDCBA'}
                {options.lowercase && 'zyxwvutsrqponmlkjihgfedcba'}
                {options.symbols && '!@#$%^&*()_+-=[]{}|;:,.<>?'}
              </div>
            </div>
            
            <div className="checkbox-options">
              <p>Варианты:</p>
              <div className="option">
                <input 
                  type="checkbox" 
                  id="lowercase" 
                  name="lowercase" 
                  checked={options.lowercase} 
                  onChange={handleCheckboxChange} 
                />
                <label htmlFor="lowercase">Маленькие буквы</label>
              </div>
              
              <div className="option">
                <input 
                  type="checkbox" 
                  id="uppercase" 
                  name="uppercase" 
                  checked={options.uppercase} 
                  onChange={handleCheckboxChange} 
                />
                <label htmlFor="uppercase">Заглавные буквы</label>
              </div>
              
              <div className="option">
                <input 
                  type="checkbox" 
                  id="numbers" 
                  name="numbers" 
                  checked={options.numbers} 
                  onChange={handleCheckboxChange} 
                />
                <label htmlFor="numbers">Цифры</label>
              </div>
              
              <div className="option">
                <input 
                  type="checkbox" 
                  id="symbols" 
                  name="symbols" 
                  checked={options.symbols} 
                  onChange={handleCheckboxChange} 
                />
                <label htmlFor="symbols">Знаки</label>
              </div>
            </div>
            
            <div className="length-option">
              <label htmlFor="length">Длина пароля: </label>
              <input 
                type="number" 
                id="length" 
                name="length" 
                value={options.length} 
                onChange={handleInputChange} 
                min="1" 
                max="99" 
              />
              <span>(max: 99)</span>
            </div>
            
            <div className="count-option">
              <label htmlFor="count">Количество паролей: </label>
              <input 
                type="number" 
                id="count" 
                name="count" 
                value={options.count} 
                onChange={handleInputChange} 
                min="1" 
                max="99" 
              />
              <span>(max: 99)</span>
            </div>
            
            <button 
              className="generate-button" 
              onClick={generatePasswords} 
              disabled={isLoading}
            >
              {isLoading ? 'Генерация...' : 'Создать пароль!'}
            </button>
            
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>
        
        <div className="results-section">
          <h2>Результат сгенерированных паролей</h2>
          
          <ol className="password-list">
            {passwords.map((password, index) => (
              <li key={index}>
                <div className="password-item">
                  <span className="password-text">{password}</span>
                  <button 
                    className="copy-button" 
                    onClick={() => copyToClipboard(password, index)}
                    title="Скопировать пароль"
                  >
                    {copiedIndex === index ? "✓" : "📋"}
                  </button>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </main>
    </div>
  );
}

export default App;
